import PageContainer from "../components/PageContainer";
import CategoryCardContainer from '../components/CategoryCardContainer';
import CategoryCard from "../components/CategoryCard";
import { waterCategories, airCategories, landCategories, snowCategories, bestViewsCategories } from "../data/categoryList";
import { useEffect, useState } from "react";
import ActivityTypeSelect from "../components/poolBar/ActivityTypeSelect";
import { useDispatch, useSelector } from "react-redux";
import { setCategoryNull, setNewFilters } from "../redux/filtersSlice";
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet';
import usePageTracking from "../hooks/usePageTracking";

const ChooseCategory = () => {

    const { pageTitle, description } = usePageTracking({
        pageTitle: "Scegli la categoria",
    })

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { filtersObject } = useSelector(state => state.filters);
    useEffect(() => {
        dispatch(setCategoryNull());
    }, [dispatch])
    const [array, setArray] = useState(null)
    useEffect(() => {
        if (filtersObject.activityType) {
            switch (filtersObject.activityType[0]) {
                case "Acqua":
                    setArray(waterCategories);
                    break;
                case "Aria":
                    setArray(airCategories);
                    break;
                case "Terra":
                    setArray(landCategories);
                    break;
                case "Neve":
                    setArray(snowCategories);
                    break;
                case "Best Views":
                    setArray(bestViewsCategories)
                    break;
                default:
                    break;
            }
        } else {
            setArray([
                ...waterCategories,
                ...airCategories,
                ...landCategories,
                ...snowCategories,
                ...bestViewsCategories
            ])
        }
    }, [filtersObject.activityType])

    const handleFilters = (event) => {
        const { id, value } = event.target;
        let fixedId;
        let fixedValue;
        if (id === 'activityType') {
            fixedId = id;
            fixedValue = value === 'Tutti' ? null : value;
        }
        dispatch(setNewFilters({ [fixedId]: fixedValue }))
    }
    return (
        <PageContainer items="center">
            <Helmet>
                <title>{pageTitle} - TicinoWild</title>
                <meta name="description" content="Scegli fra le macro categorie disponibili: Acqua, Terra, Aria, Neve e Best View" />
            </Helmet>
            <h2>Scegli tra le categorie</h2>
            {/* activityType select */}
            <ActivityTypeSelect typeFilter={filtersObject.activityType} handleFilters={handleFilters} />

            <CategoryCardContainer>
                {
                    array && array.length > 0 && [...array]
                        .sort((a, b) => t(a.label).localeCompare(t(b.label)))
                        .map((element, index) => {
                            return (
                                <CategoryCard
                                    key={index}
                                    title={t(element.label)}
                                    photo={element.resizedPhoto}
                                    filterString={`category-${element.name}`}
                                />
                            )
                        })
                }
            </CategoryCardContainer>
        </PageContainer>
    )
}

export default ChooseCategory